import { render, staticRenderFns } from "./ActiveSubstanceAdd.vue?vue&type=template&id=87594fba&scoped=true&"
import script from "./ActiveSubstanceAdd.vue?vue&type=script&lang=js&"
export * from "./ActiveSubstanceAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87594fba",
  null
  
)

export default component.exports